<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Dropdowns</strong></h4>
      <a href="https://mdbootstrap.com/vue/components/dropdowns/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-5" />
    <container class="mt-5">
      <h4 class="pb-1">Material dropdown</h4>
      <dropdown>
        <dropdown-toggle color="primary" slot="toggle">Material dropdown</dropdown-toggle>
        <dropdown-menu color="primary">
          <dropdown-item>Action</dropdown-item>
          <dropdown-item>Another action</dropdown-item>
          <dropdown-item>Something else here</dropdown-item>
          <div class="dropdown-divider"></div>
          <dropdown-item>Separated link</dropdown-item>
        </dropdown-menu>
      </dropdown>
      <h4 class="pt-4 pb-1">Color variations</h4>
      <dropdown>
        <dropdown-toggle color="danger" slot="toggle">Danger dropdown</dropdown-toggle>
        <dropdown-menu color="danger">
          <dropdown-item>Action</dropdown-item>
          <dropdown-item>Another action</dropdown-item>
          <dropdown-item>Something else here</dropdown-item>
          <div class="dropdown-divider"></div>
          <dropdown-item>Separated link</dropdown-item>
        </dropdown-menu>
      </dropdown>
      <dropdown>
        <dropdown-toggle color="warning" slot="toggle">Warning dropdown</dropdown-toggle>
        <dropdown-menu color="warning">
          <dropdown-item>Action</dropdown-item>
          <dropdown-item>Another action</dropdown-item>
          <dropdown-item>Something else here</dropdown-item>
          <div class="dropdown-divider"></div>
          <dropdown-item>Separated link</dropdown-item>
        </dropdown-menu>
      </dropdown>
      <dropdown>
        <dropdown-toggle color="info" slot="toggle">Info dropdown</dropdown-toggle>
        <dropdown-menu color="info">
          <dropdown-item>Action</dropdown-item>
          <dropdown-item>Another action</dropdown-item>
          <dropdown-item>Something else here</dropdown-item>
          <div class="dropdown-divider"></div>
          <dropdown-item>Separated link</dropdown-item>
        </dropdown-menu>
      </dropdown>
    </container>
  </container>
</template>

<script>
import { Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Fa } from 'mdbvue';

export default {
  name: 'DropdownPagePro',
  components: {
    Container,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Fa,
    Row
  }
};
</script>

<style scoped>
</style>
